import {isValidElement, useMemo} from 'react';

import PropTypes from 'prop-types';

import Glyphicon from '../glyphicon/Glyphicon';

import './Input.scss';

const DISPLAY_NAME = 'com-input';

function Input({id, type, onClick, disabled, readOnly, className, value, icon}) {
  const renderIcon = useMemo(() => {
    if (typeof icon === 'string')
      return (
        <Glyphicon
          glyph={icon}
          className="com-input-icon"
        />
      );
    if (isValidElement(icon)) return icon;

    return null;
  }, [icon]);

  const memoizedClassName = useMemo(() => {
    const res = [DISPLAY_NAME];

    if (className) res.push(className);
    if (readOnly) res.push('readOnly');
    if (disabled) res.push('disabled');

    return res.join(' ');
  }, [className, disabled, readOnly]);

  return (
    <div
      className={memoizedClassName}
      id={`${DISPLAY_NAME}-${id}`}
    >
      <input
        className="form-control"
        value={value}
        id={id}
        readOnly={readOnly}
        disabled={disabled}
        onClick={onClick}
        type={type}
      />
      {renderIcon}
    </div>
  );
}

Input.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  className: PropTypes.string,
  value: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

Input.defaultProps = {
  id: DISPLAY_NAME,
  type: 'text',
  onClick: () => {},
  disabled: false,
  readOnly: false,
  className: '',
  value: '',
  icon: false,
};

export default Input;
